import { FancyNumberPipe } from "../shared/directives/fancy-number.pipe";
import { BalanceCard } from "../shared/project/cards/balance-card";
import { Card } from "../shared/project/cards/card";
import { VarianceModel } from "../shared/project/cards/cards-model";
import { CardHelper } from "./cardHelper";
import { WaterfallItem } from "./waterfall-item";

export class BaseCardsComponent {
    blockHeight: number = 42;
    
    public varianceModel: VarianceModel

    showWaterfall: boolean = true;
    seqMode: boolean = true;
    showOutOfScope: boolean = false;
    waterfallItems: WaterfallItem[] = [];
    waterfallItemsOutOfScope: WaterfallItem[] = [];

    endOfScopeOutcomeTop: number = 0;
    oldOutcomeTop: number = 0;
    newOutcomeTop: number = 0;
    
    totalOutcomeCtx = FancyNumberPipe.createDefaultContext();
    cardOutcomeCtx = FancyNumberPipe.createDefaultContext();
    cardPercCtx = {
        roundTo: 1,
        scale: undefined,
        showPlusForPositive: true,
        use2stepRounding: false,
    };
    
    private shouldShowOutOfScope() {
        return this.showOutOfScope && this.varianceModel.outOfScopeCards && this.varianceModel.outOfScopeCards.length;
    }

    protected loadWaterfallItems(cards: Card[], outOfScopeCards: Card[], balanceCard: BalanceCard) {
        const totalHeight = this.blockHeight;
        let waterfallItems = new Array<WaterfallItem>(cards.length);
        let min = 0, max = 0, curVal = 0, minI = 0, maxI = 0; 
        for (let i = 0; i < cards.length; ++i) {
            let seqDiff = this.shouldShowOutOfScope() ? cards[i].seqChartDiffWithOutOfScope : cards[i].seqChartDiff;
            let absDiff = this.shouldShowOutOfScope() ? cards[i].absChartDiffWithOutOfScope : cards[i].absChartDiff;
            curVal += seqDiff;
            if (min > curVal) {
                min = curVal;
                minI = i;
            } else if (max < curVal) {
                max = curVal;
                maxI = i;
            }
            if (!this.seqMode) {
                let valWithAbsDiff = curVal - seqDiff + absDiff;
                if (min > valWithAbsDiff) {
                    min = valWithAbsDiff;
                    minI = i;
                } else if (max < valWithAbsDiff) {
                    max = valWithAbsDiff;
                    maxI = i;
                }
            }
        }
        let valBeforeBalanceCard = curVal;
        let maxWithoutOutOfScope = max;
        let outOfScopeMaxModifier: number = undefined;
        if (this.shouldShowOutOfScope()) {
            for (let i = 0; i < outOfScopeCards.length; ++i) {
                let seqDiff = outOfScopeCards[i].seqChartDiff;
                let absDiff = outOfScopeCards[i].absChartDiff;
                curVal += seqDiff;
                if (min > curVal) {
                    min = curVal;
                    //minI = i;
                } else if (max < curVal) {
                    max = curVal;
                    //maxI = i;
                }
                if (!this.seqMode) {
                    let valWithAbsDiff = curVal - seqDiff + absDiff;
                    if (min > valWithAbsDiff) {
                        min = valWithAbsDiff;
                       // minI = i;
                    } else if (max < valWithAbsDiff) {
                        max = valWithAbsDiff;
                     //   maxI = i;
                    }
                }
            }
            if (maxWithoutOutOfScope < max) {
                outOfScopeMaxModifier = max - maxWithoutOutOfScope;
            }
        }
        let maxIsBalance = false;
        curVal = valBeforeBalanceCard;
        if (balanceCard) {
            if (this.shouldShowOutOfScope()) {
                curVal += balanceCard.chartDiffWithOutOfScope;
            } else {
                curVal += balanceCard.chartDiff;
            }
            if (min > curVal) {
                min = curVal;
            } else if (max < curVal) {
                max = curVal;
                maxIsBalance = true;
            }
        }
        let maxDiff = max - min;

        const topBorder = 10;
        let curTop = topBorder;
        if (outOfScopeMaxModifier != undefined) {
            curTop += outOfScopeMaxModifier * totalHeight / maxDiff;
        }
        let absModeMargin = 0;
        if (!this.seqMode) {
            if (this.shouldShowOutOfScope() && cards[maxI].absChartDiffWithOutOfScope > 0 && cards[maxI].absChartDiffWithOutOfScope > cards[maxI].seqChartDiffWithOutOfScope) {
                absModeMargin = (cards[maxI].absChartDiffWithOutOfScope - Math.max(0, cards[maxI].seqChartDiffWithOutOfScope)) * totalHeight / maxDiff;
                curTop += absModeMargin;
            } else if (cards[maxI].absChartDiff > 0 && cards[maxI].absChartDiff > cards[maxI].seqChartDiff) {
                absModeMargin = (cards[maxI].absChartDiff - Math.max(0, cards[maxI].seqChartDiff)) * totalHeight / maxDiff;
                curTop += absModeMargin;
            }
        }
        let balanceItem: WaterfallItem;
        if (maxIsBalance) {
            balanceItem = new WaterfallItem();
            balanceItem.absColor = balanceItem.seqColor = this.shouldShowOutOfScope() ? balanceCard.chartColorWithOutOfScope : balanceCard.chartColor;
            let chartDiff = this.shouldShowOutOfScope() ? balanceCard.chartDiffWithOutOfScope : balanceCard.chartDiff;
            balanceItem.absHeight = balanceItem.seqHeight = Math.abs(chartDiff * totalHeight / maxDiff);
            balanceItem.absTop = -1;
            balanceItem.seqTop = curTop;
            curTop += chartDiff > 0 ? balanceItem.seqHeight : -balanceItem.seqHeight;
            maxI = cards.length - 1;
        }
        for (let i = maxI; i >= 0 && cards.length; --i) {
            let seqDiff = this.showOutOfScope ? cards[i].seqChartDiffWithOutOfScope : cards[i].seqChartDiff;
            let absDiff = this.showOutOfScope ? cards[i].absChartDiffWithOutOfScope : cards[i].absChartDiff;
            let item = new WaterfallItem();
            item.seqColor = this.shouldShowOutOfScope()
                ? this.seqMode ? cards[i].seqChartColorSeqModeWithOutOfScope : cards[i].seqChartColorAbsModeWithOutOfScope
                : this.seqMode ? cards[i].seqChartColorSeqMode : cards[i].seqChartColorAbsMode;
            item.absColor = cards[i].absChartColor;
            item.seqHeight = Math.abs(seqDiff * totalHeight / maxDiff);
            item.absHeight = Math.abs(absDiff * totalHeight / maxDiff);
            item.seqTop = curTop;
            if (seqDiff < 0 && (i != maxI || (i == maxI && maxIsBalance))) {
                item.seqTop -= item.seqHeight;
            }
            this.calcAbsTop(item, cards[i]);
            waterfallItems[i] = item;
            curTop += seqDiff > 0 ? item.seqHeight : -item.seqHeight;
        }
        curTop = absModeMargin;
        if (outOfScopeMaxModifier != undefined) {
            curTop += outOfScopeMaxModifier * totalHeight / maxDiff;
        }
        if (maxIsBalance) {
            curTop += (balanceCard.chartDiff > 0 ? topBorder : topBorder + balanceItem.seqHeight);
        } else if (cards && cards.length) {
            curTop += ((this.showOutOfScope ? cards[maxI].seqChartDiffWithOutOfScope : cards[maxI].seqChartDiff) > 0 ? topBorder : topBorder + waterfallItems[maxI].seqHeight);
        }
        for (let i = maxI + 1; i < cards.length; ++i) {
            let seqDiff = this.showOutOfScope ? cards[i].seqChartDiffWithOutOfScope : cards[i].seqChartDiff;
            let absDiff = this.showOutOfScope ? cards[i].absChartDiffWithOutOfScope : cards[i].absChartDiff;
            let item = new WaterfallItem();
            item.seqColor = this.shouldShowOutOfScope()
                ? this.seqMode ? cards[i].seqChartColorSeqModeWithOutOfScope : cards[i].seqChartColorAbsModeWithOutOfScope
                : this.seqMode ? cards[i].seqChartColorSeqMode : cards[i].seqChartColorAbsMode;
            item.absColor = cards[i].absChartColor;
            item.seqHeight = Math.abs(seqDiff * totalHeight / maxDiff);
            item.absHeight = Math.abs(absDiff * totalHeight / maxDiff);
            item.seqTop = curTop;
            if(seqDiff > 0) {
                item.seqTop -=  item.seqHeight;
            }
            this.calcAbsTop(item, cards[i]);
            waterfallItems[i] = item;
            curTop += seqDiff < 0 ? item.seqHeight : -item.seqHeight;
        }
        if (!maxIsBalance && balanceCard) {
            balanceItem = new WaterfallItem();
            balanceItem.absColor = balanceItem.seqColor = this.shouldShowOutOfScope ? balanceCard.chartColorWithOutOfScope : balanceCard.chartColor;
            let chartDiff = this.shouldShowOutOfScope() ? balanceCard.chartDiffWithOutOfScope : balanceCard.chartDiff;
            balanceItem.absHeight = balanceItem.seqHeight = Math.abs(chartDiff * totalHeight / maxDiff);

            balanceItem.seqTop = chartDiff < 0 ? curTop : curTop - balanceItem.seqHeight;
            balanceItem.absTop = -1;
        }
        if (balanceCard) {
            waterfallItems.push(balanceItem);
            if (balanceCard.chartDiff > 0) {
                this.endOfScopeOutcomeTop = balanceItem.seqTop;
            } else {
                this.endOfScopeOutcomeTop = balanceItem.seqTop + balanceItem.seqHeight;
            }
        } else if (cards && cards.length){
            this.endOfScopeOutcomeTop = waterfallItems[waterfallItems.length - 1].seqTop + (cards[cards.length - 1].seqDriverValue < 0 ? waterfallItems[waterfallItems.length - 1].seqHeight : 0);
        }

        if (cards.length) {
            if (cards[0].seqChartDiff > 0) {
                this.oldOutcomeTop = waterfallItems[0].seqTop + waterfallItems[0].seqHeight;
            } else {
                this.oldOutcomeTop = waterfallItems[0].seqTop;
            }
        } else if (balanceCard) {
            if (balanceCard.chartDiff > 0) {
                this.oldOutcomeTop = balanceItem.seqTop + balanceItem.seqHeight;
            } else {
                this.oldOutcomeTop = balanceItem.seqTop;
            }
        }
        else {
            this.oldOutcomeTop = 0;
        }
        if (balanceCard) {
            if (balanceCard.chartDiff > 0) {
                this.newOutcomeTop = balanceItem.seqTop;
            } else {
                this.newOutcomeTop = balanceItem.seqTop + balanceItem.seqHeight;
            }
        } else if (cards.length){
            if (cards[cards.length - 1].seqChartDiff > 0) {
                this.newOutcomeTop = waterfallItems[cards.length - 1].seqTop;
            } else {
                this.newOutcomeTop = waterfallItems[cards.length - 1].seqTop + waterfallItems[cards.length - 1].seqHeight;
            }
        } else {
            this.newOutcomeTop = 0;
        }

        this.waterfallItems = waterfallItems;
        this.loadWaterfallItemsOutOfScope(outOfScopeCards, maxDiff);
    }

    
    private loadWaterfallItemsOutOfScope(cards: Card[], maxDiff: number)
    {
        if (!cards || !cards.length) {
            this.waterfallItemsOutOfScope = [];
            return;
        }
        const totalHeight = this.blockHeight;
        let waterfallItems = new Array<WaterfallItem>(cards.length);
        let min = 0, max = 0, curVal = 0, minI = 0, maxI = 0; 
        for (let i = 0; i < cards.length; ++i) {
            curVal += cards[i].seqChartDiff;
            if (min > curVal) {
                min = curVal;
                minI = i;
            } else if (max < curVal) {
                max = curVal;
                maxI = i;
            }
            if (!this.seqMode) {
                let valWithAbsDiff = curVal - cards[i].seqChartDiff + cards[i].absChartDiff;
                if (min > valWithAbsDiff) {
                    min = valWithAbsDiff;
                    minI = i;
                } else if (max < valWithAbsDiff) {
                    max = valWithAbsDiff;
                    maxI = i;
                }
            }
        }

        const topBorder = 10;
        let curTop = this.endOfScopeOutcomeTop;
        let absModeMargin = 0;
        if (!this.seqMode && cards[maxI].absChartDiff > 0 && cards[maxI].absChartDiff > cards[maxI].seqChartDiff) {
            absModeMargin = (cards[maxI].absChartDiff - Math.max(0, cards[maxI].seqChartDiff)) * totalHeight / maxDiff;
            curTop += absModeMargin;
        }
        for (let i = 0; i < cards.length; ++i) {
            let item = new WaterfallItem();
            item.seqColor = this.seqMode ?  cards[i].seqChartColorSeqMode : cards[i].seqChartColorAbsMode;
            item.absColor = cards[i].absChartColor;
            item.seqHeight = Math.abs(cards[i].seqChartDiff * totalHeight / maxDiff);
            item.absHeight = Math.abs(cards[i].absChartDiff * totalHeight / maxDiff);
            item.seqTop = curTop;
            if(cards[i].seqChartDiff > 0) {
                item.seqTop -=  item.seqHeight;
            }
            this.calcAbsTop(item, cards[i]);
            waterfallItems[i] = item;
            curTop += cards[i].seqChartDiff < 0 ? item.seqHeight : -item.seqHeight;
        }
        
        if (this.shouldShowOutOfScope()) {
            if (cards[cards.length - 1].seqChartDiff > 0) {
                this.newOutcomeTop = waterfallItems[cards.length - 1].seqTop;
            } else {
                this.newOutcomeTop = waterfallItems[cards.length - 1].seqTop + waterfallItems[cards.length - 1].seqHeight;
            }
        }

        this.waterfallItemsOutOfScope = waterfallItems;
    }

    private calcAbsTop(item: WaterfallItem, card: Card): void {
        //abs top is relative to seq top;
        if (card.absChartDiff < 0) {
            item.absTop = card.seqChartDiff < 0 
                ? -1
                : item.seqHeight - 1;
        } else {
            item.absTop = card.seqChartDiff < 0 
                ? - item.absHeight - 1
                : item.seqHeight - item.absHeight - 1;
        }
    }

    protected calcOutcomeCtxs() {
        this.totalOutcomeCtx = CardHelper.calcOutcomeFancyNumContext(this.varianceModel.cards, [ this.varianceModel.oldTotalOutcome, this.varianceModel.newTotalOutcome ]);
        this.cardOutcomeCtx = CardHelper.calcOutcomeFancyNumContext(this.varianceModel.cards, [ this.varianceModel.oldTotalOutcome, this.varianceModel.newTotalOutcome ]);
        this.cardOutcomeCtx.showPlusForPositive = true;
    }

}